import { StateCreator } from "zustand";
import { AxiosHttpClient } from "../../infra/http/axios-http-client";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY } from "../../base";
import { RemoteDownloadExcel } from "../../data/usecases/remote-download-excel";
import Endpoints from "../../domain/endpoints";
import { DownloadExcel } from "../../domain/useages/download-excel";
import { customerDatabaseFilters } from "../../domain/models/customer-database/customer-database-filters";
import { getDataKeyFromLocalStorage } from "../../common/utils/AuthToken";

export interface DownloadExcelInterface {
  downloadExcel: Function;
  downloadingExcel: Boolean;
}

const initialStates = {
  downloadingExcel: false,
};

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useDownloadExcelSlice: StateCreator<DownloadExcelInterface> = (
  set
) => ({
  ...initialStates,
  downloadExcel: async (filterStore: customerDatabaseFilters) => {
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);
    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteDownloadExcel: DownloadExcel = new RemoteDownloadExcel(
      `${BASE_URL}${Endpoints.FETCH_CUSTOMERS}`,
      axiosHttpClient
    );

    try {
      let response = await remoteDownloadExcel.download(filterStore);

      if (response) {
        set(() => ({ downloadingExcel: false }));
      }
    } catch (error) {
      console.error(error);
    }
  },
});
